import Vue from 'vue'
import VueRouter from 'vue-router'

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const originalReplace = VueRouter.prototype.replace;
VueRouter.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => err);
};
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: (reslove) => require(['@/views/NavBottom.vue'], reslove),
    children: [
      {
        path: '/',
        redirect: '/terminal',
      },
      {
        /**
         * 首页
         */
        path: '/index',
        name: 'Index',
        meta: {
          title: 'home'
        },
        component: (reslove) => require(['@/views/Index.vue'], reslove),
      },
       {
        /**
         * 终端信息
         */
        path: '/terminal',
        name: 'terminal',
        meta: {
          title: 'terminal'
        },
        component: (reslove) => require(['@/views/Terminal.vue'], reslove),
      }, {
        /**
         * 终端
         */
        path: '/information',
        name: 'information',
        meta: {
          title: 'terminal_info'
        },
        component: (resolve) => require(['@/views/Tinformation.vue'], resolve),
      },
       {
        /**
         * 节目
         */
        path: '/program',
        name: 'Program',
        meta: {
          title: 'program'
        },
        component: (reslove) => require(['@/views/Programs.vue'], reslove),
      }, {
        /**
         * 我的
         */
        path: '/my',
        name: 'My',
        meta: {
          title: 'my'
        },
        component: (reslove) => require(['@/views/My.vue'], reslove),
      }, {
        /**
         *遥控
         */
        path: '/telecontrol',
        name: 'telecontrol',
        meta: {
          title: 'remote_control'
        },
        component: (reslove) => require(['@/components/telecontrol.vue'], reslove),
        },

      {
        /**
         * 审核管理
         */
        path: '/audit',
        name: 'audit',
        meta: {
          title: 'audit'
        },
        component: (resolve) => require(['@/components/audit.vue'], resolve),
      },
      {
        /**
         * 资料下载
         */
        path: '/myExplain',
        name: 'myExplain',
        meta: {
          title: 'myExplain'
        },
        component: (resolve) => require(['@/views/myExplain.vue'], resolve),
      },
      {
        /**
         * 系统帮助
         */
        path: '/systemHelp',
        name: 'systemHelp',
        meta: {
          title: 'systemHelp'
        },
        component: (resolve) => require(['@/views/systemHelp.vue'], resolve),
      },
      {
        /**
         * 客户查询编辑
         */
        path: '/customers',
        name: 'customers',
        meta: {
          title: 'customers'
        },
        component: (resolve) => require(['@/views/customers.vue'], resolve),
      },

      {
        /**
         * 素材回收站
         */
        path: '/materialRecycleBin',
        name: 'materialRecycleBin',
        meta: {
          title: 'materialRecycleBin',
        },
        component: (resolve) => require(['@/views/MaterialRecycleBin.vue'], resolve),
      },
      {
        /*
        * 绑定任务 taskInfo
        * */
        path: '/taskInfo',
        name: 'taskInfo',
        meta: {
          title: 'taskInfo'
        },
        component: (reslove) => require(['@/views/taskInfo.vue'], reslove),
      },
      {
        /*
        * 定时开关机 scheduleOnOff.vue
        * */
        path: '/scheduleOnOff',
        name: 'scheduleOnOff',
        meta: {
          title: 'taskInfo'
        },
        component: (reslove) => require(['@/views/scheduleOnOff.vue'], reslove),
      },

    ],
  },
  {
    /**
     * 创建节目
     */
    path: '/createProrram',
    name: 'createProrram',
    meta: {
      title: 'create_program'
    },
    component: (resolve) => require(['@/views/program-editor/CreateProrram.vue'], resolve),
  },

      {
    path: '/material',
    name: 'material',
    meta: {
      title: 'material_management'
    },
    component: (resolve) => require(['@/components/material.vue'], resolve),
  },
  {
    /**
     * 登录
     */
    path: '/login',
    name: 'Login',
    meta: {
      title: 'login'
    },
    component: (resolve) => require(['@/views/Login.vue'], resolve),
  },
  {
    path: '/resetPwd',
    name: 'resetPwd',
    meta: {
      title: 'reset_password'
    },
    component: (resolve) => require(['@/views/resetPwd.vue'], resolve),
  },
  {
    /**
     * 注册
     */
    path: '/Register',
    name: 'Register',
    meta: {
      title: 'login'
    },
    component: (resolve) => require(['@/views/Register.vue'], resolve),
  },
      {
    /**
     * 注册
     */
    path: '/Help',
    name: 'Help',
    meta: {
      title: 'Help'
    },
    component: (resolve) => require(['@/views/Help.vue'], resolve),
  },
  {
    path: '/editPass',
    name: 'editPass',
    meta: {
      title: 'change_password'
    },
    component: (resolve) => require(['@/views/editPass.vue'], resolve),
  },

  {
    /*
    * 设备列表管理
    * */
    path: '/deviceListManagement',
    name:'deviceListManagement',
    meta:{
      title:'deviceListManagement',

    },
    component:(resolve) =>require(['@/views/deviceListManagement.vue'],resolve)
  },
  {
    /**
     * 任务详情
     */
    path: '/taskdetail',
    name: 'taskdetail',
    meta: {
      title: 'task_details'
    },
    component: (reslove) => require(['@/components/taskdetail.vue'], reslove),
  }, {
    /**
     * 节目列表
     */
    path: '/programItem',
    name: 'programItem',
    meta: {
      title: 'program_list'
    },
    component: (resolve) => require(['@/views/programItem.vue'], resolve),
  },
  {
    /**
     * 预览
     */
    path: '/sr',
    name: '终端扫码跳转更多页面',
    meta: {
      title: 'ScanRedirectPage'
    },
    component: (resolve) => require(['@/views/ScanRedirectPage.vue'], resolve),
  },
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes,
})

export default router
